import { JitsiConnectionEvents } from 'nexgen-types/lib-jitsi';

export const isJitsiConnectionEvent = (event: string): event is JitsiConnectionEvents => {
  return Object.values(JitsiConnectionEvents).includes(event as JitsiConnectionEvents);
};

export const isJitsiConnectionSuccessEvent = (event: string): event is JitsiConnectionEvents => {
  return isJitsiConnectionEvent(event) && event === JitsiConnectionEvents.CONNECTION_ESTABLISHED;
};

export const isJitsiConnectionFailedEvent = (event: string): event is JitsiConnectionEvents => {
  return isJitsiConnectionEvent(event) && event === JitsiConnectionEvents.CONNECTION_FAILED;
};

export const isJitsiConnectionDisconnectedEvent = (
  event: string
): event is JitsiConnectionEvents => {
  return isJitsiConnectionEvent(event) && event === JitsiConnectionEvents.CONNECTION_DISCONNECTED;
};

export const getJitsiConnectionConfig = (roomId?: string) => {
  const domain = import.meta.env.VITE_JITSI_DOMAIN;
  const appId = import.meta.env.VITE_JITSI_APP_ID;

  return {
    hosts: {
      domain,
      muc: `conference.${appId}.8x8.vc`,
    },
    serviceUrl: `wss://8x8.vc/${appId}/xmpp-websocket?room=${roomId}`,
    websocketKeepAliveUrl: `https://8x8.vc/${appId}/_unlock?room=${roomId}`,
  };
};
